// GQL
import { client } from '../../../../gql/client';
import { RECALCULATE_BASIC_SCHEDULE } from '../../../../gql/mutations/surveillanceRoute';

/**
 * Pide al back el horario de la básica recalculado desde el hueco de su tramo
 * (12-oct). Es una acción del momento: NO pasa por la cola sin red
 * (`skipOfflineQueue`); sin red o con error, el error sube y quien llama avisa.
 * Devuelve inicio y fin como en el formulario ('' = vacío).
 */
export const requestBasicScheduleRecalculation = async (
  orderId: string
): Promise<{ registerInitDate: string; registerEndDate: string }> => {
  const { data } = await client.mutate<{
    recalculateBasicSchedule?: {
      registerInitDate?: string | null;
      registerEndDate?: string | null;
    };
  }>({
    mutation: RECALCULATE_BASIC_SCHEDULE,
    variables: { orderId },
    context: { skipOfflineQueue: true },
  });
  const order = data?.recalculateBasicSchedule;
  return {
    registerInitDate: order?.registerInitDate ?? '',
    registerEndDate: order?.registerEndDate ?? '',
  };
};
